import StaticImageDetailModel from "./StaticImageDetailModel.js";
import StaticImageDetailRenderer from "./StaticImageDetailRenderer.js";
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: StaticImageDetailModel.TYPE,
      model: StaticImageDetailModel
    });
    molten.addPlugin('DetailRenderer', {
      type: StaticImageDetailModel.TYPE,
      renderer: StaticImageDetailRenderer
    });
  }
};